import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import PlanSelect from "./components/PlanSelect";
import Button from "@/components/Button";

export const Wrapper = styled.div`
	position: relative;
`;

export const CloseButton = styled(IconButton)`
	position: absolute;
	top: 42px;
	right: 74px;
	z-index: 1000;
`;

export const Content = styled.div`
	width: 100%;
	max-width: 1100px;
	margin: 0 auto;
	padding: 132px 0;
`;

export const MainTitle = styled.p`
	font-size: 40px;
	font-weight: bold;
	color: #121212;
	padding-bottom: 106px;
	border-bottom: 1px solid #e0e0e0;
	margin-bottom: 34px;
`;

export const SectionTitle = styled.p`
	font-size: 1.375rem;
	font-weight: 700;
	line-height: 1.5rem;
	color: #121212;
	margin-bottom: 2rem;
`;

export const ContentItemWrapper = styled.div`
	width: 100%;
	margin-bottom: 70px;

	&:nth-last-of-type(1) {
		margin-bottom: 0;
	}
`;

export const ContentTitle = styled.p`
	font-size: 16px;
	line-height: 24px;
	margin-bottom: 10px;
`;

export const ContentBox = styled.div`
	border: 1px solid #e0e0e0;
	padding: 0 28px;
	border-radius: 4px;
	align-items: stretch;
	display: flex;
`;

export const OrganizationWrapper = styled.div`
	width: 270px;
	border-right: 1px solid #e0e0e0;
	padding: 26px 26px 26px 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const OrganizationTopWrapper = styled.div``;

export const OrganizationTitle = styled.p`
	font-size: 13px;
	margin-bottom: 18px;
`;

export const OrganizationPlanTitle = styled.p`
	font-size: 22px;
	font-weight: bold;
	margin-bottom: 15px;
`;

export const OrganizationPlanAmount = styled.p`
	font-size: 14px;
`;

export const OrganizationPrice = styled.p`
	font-size: 28px;
	font-weight: bold;
	display: flex;
	align-items: flex-end;
`;

export const OrganizationPriceDate = styled.span`
	font-size: 14px;
	line-height: 28px;
	margin-left: 6px;
	font-weight: normal;
`;

export const ContactUsGuideWrapper = styled.div`
	flex-grow: 1;
	padding: 25px 40px 30px 40px;
`;

export const ContactUsGuideContent = styled.div`
	flex-grow: 1;
`;

export const ContactUsSendButton = styled(Button)`
	width: 100%;
`;

export const ModalTitle = styled.p`
	font-size: 14px;
	line-height: 28px;
	margin-bottom: 4px;
`;

/* export const PlanWrapper = styled.div`
	flex-grow: 1;
	padding: 25px 40px 30px 40px;
`; */

export const PlanSelectTitle = styled.p`
	font-size: 13px;
	margin-bottom: 8px;
`;

export const StyledPlanSelect = styled(PlanSelect)`
	margin-bottom: 14px;
`;

export const PlanEffectiveWrapper = styled.div`
	display: flex;
	align-items: flex-start;
	padding-bottom: 26px;
	border-bottom: 1px solid #c4c4c4;
	margin-bottom: 30px;
`;

export const PlanEffectiveCategory = styled.span`
	font-size: 14px;
	margin-right: 62px;
	line-height: 24px;
`;

export const PlanEffectiveContentWrapper = styled.div`
	flex-grow: 1;
`;

export const PlanEffectiveContentTitle = styled.p`
	font-size: 14px;
	color: #2a1bda;
	line-height: 24px;
`;

export const PlanEffectiveContentSubtitle = styled.p`
	font-size: 14px;
	line-height: 24px;
`;

export const PlanChangeButton = styled(Button)`
	width: 300px;
	margin: 0 auto;
	display: block;
`;

export const PlanTableWrapper = styled.div`
	width: 100%;
	padding: 28px 0 40px 0;
`;

export const TableTdLink = styled(Link)`
	font-size: 14px;
	color: #2a1bda;
	text-decoration: underline;
`;
